goog.provide('el8.apphome.docMgr.renderer');

goog.require('el8.template.render.docMgr.sorter');
goog.require('el8.template.render.docMgr.organizer');
goog.require('el8.template.render.docMgr.filer');

el8.apphome.docMgr.renderer.inboxItemContent = function(_item) {
    var mClass = _item.getModelClass();
    switch(mClass) {
        case 'IncomingFileGroup':
            return function(item, feedItemId) {
                var obj = item.asSoyMap();
                return el8.template.render.docMgr.organizer.fileGroupContent(obj);
            };
    };
    return null;
};

el8.apphome.docMgr.renderer.sorter = function(mClass) {
    switch(mClass) {
        case 'UploadedImage':
            return function(item, feedItemId) {
                var obj = item.asSoyMap();
                obj['feedItemId'] = feedItemId;
                return el8.template.render.docMgr.sorter.thumbnailImageItem(obj);
            };
        case 'UploadedFile':
            return function(item, feedItemId) {
                var obj = item.asSoyMap();
                obj['feedItemId'] = feedItemId;
                return el8.template.render.docMgr.sorter.thumbnailFileItem(obj);
            };
    };
    return null;
};

el8.apphome.docMgr.renderer.filer = function(mClass, isThumbnail) {
    switch(mClass) {
        case 'UploadedImage':
            return function(item, feedItemId) {
                var obj = item.asSoyMap();
                obj['feedItemId'] = feedItemId;
                return el8.template.render.docMgr.filer.previewImageItem(obj);
            };
        case 'UploadedFile':
            return function(item, feedItemId) {
                var obj = item.asSoyMap();
                obj['feedItemId'] = feedItemId;
                return el8.template.render.docMgr.filer.previewFileItem(obj);
            };
    };
    return null;
};

